module.exports = "<template> <div id=sio-schedule-calendar></div> </template>";